// src/components/Assets/Templates/Normal1/normal1.js
export default `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="x-apple-disable-message-reformatting" />
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
  <title>Srihari Muppalla - Email Developer</title>

  <!--[if mso]>
  <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
  </xml>
  <![endif]-->

  <style type="text/css">
    body, table, td, a { -webkit-text-size-adjust:100%; -ms-text-size-adjust:100%; }
    table, td { mso-table-lspace:0pt; mso-table-rspace:0pt; }
    table { border-collapse:collapse !important; }
    img { -ms-interpolation-mode:bicubic; border:0; height:auto; line-height:100%; outline:none; text-decoration:none; }
    body { margin:0 !important; padding:0 !important; width:100% !important; min-width:100%; background-color:#eef2f6; }
    a[x-apple-data-detectors] { color:inherit !important; text-decoration:none !important; font-size:inherit !important; font-family:inherit !important; font-weight:inherit !important; line-height:inherit !important; }
    u + #body a { color:inherit; text-decoration:none; font-size:inherit; font-family:inherit; font-weight:inherit; line-height:inherit; }

    @media screen and (max-width:600px) {
      .email-wrapper { width:100% !important; max-width:100% !important; }
      .mobile-pad { padding-left:20px !important; padding-right:20px !important; }
      .mobile-center { text-align:center !important; }
      .stack { display:block !important; width:100% !important; max-width: 100%; }
      .stack-gap { display:block !important; width:100% !important; height:12px !important; }
      .hero-name { font-size:36px !important; line-height:40px !important; }
      .hero-copy { font-size:15px !important; line-height:23px !important; }
      .section-title { font-size:21px !important; line-height:27px !important; }
      .button-link { display:block !important; width:100% !important; box-sizing:border-box !important; }
      .footer-link { display:block !important; margin-bottom:10px !important; }
    }
  </style>
</head>

<body id="body" style="margin:0; padding:0; background-color:#eef2f6; font-family:Arial, Helvetica, sans-serif;">
  <div style="display:none; max-height:0; overflow:hidden; opacity:0; color:transparent; line-height:1px; font-size:1px;">
    Email developer specializing in responsive HTML email, Outlook-safe coding, Salesforce Marketing Cloud, AMPscript, Litmus, and Email on Acid QA.
  </div>
  <div style="display:none; max-height:0; overflow:hidden; opacity:0; color:transparent; line-height:1px; font-size:1px;">
    &nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
  </div>

  <center role="article" aria-roledescription="email" lang="en" style="width:100%; background-color:#eef2f6;">
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#eef2f6;">
      <tr>
        <td align="center" style="padding:24px 12px;">
          <!--[if mso]>
          <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="600" align="center">
          <tr>
          <td>
          <![endif]-->

          <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="600" class="email-wrapper" style="width:600px; max-width:600px; background-color:#ffffff;">
            <tr>
              <td style="background-color:#0b1d3a;">
                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td width="50%" style="height:5px; font-size:0; line-height:0; background-color:#0d9488;">&nbsp;</td>
                    <td width="50%" style="height:5px; font-size:0; line-height:0; background-color:#f59e0b;">&nbsp;</td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="center" class="mobile-pad" style="background-color:#0b1d3a; padding:42px 40px 34px 40px;">
                <p style="margin:0 0 14px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:2px; text-transform:uppercase; color:#14b8a8;">
                  Available for Email Developer Roles
                </p>
                <h1 class="hero-name" style="margin:0; font-family:Georgia, 'Times New Roman', serif; font-size:50px; line-height:54px; font-weight:700; color:#ffffff;">
                  Srihari Muppalla
                </h1>
                <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; letter-spacing:.8px; color:#d7e1ea;">
                  Email Developer | Campaign Analyst | Frontend Engineer
                </p>
                <p class="hero-copy" style="margin:22px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:25px; color:#e8edf5;">
                  I build responsive, production-ready HTML emails and campaign assets that render cleanly across Outlook, Gmail, Apple Mail, and mobile inboxes.
                </p>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#0d9488; padding:22px 36px;">
                <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:24px; color:#ffffff; text-align:center;">
                  Hand-coded HTML/CSS, Salesforce Marketing Cloud, AMPscript, Litmus, Email on Acid, responsive design, landing pages, campaign QA, and troubleshooting for live marketing campaigns.
                </p>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#ffffff; padding:30px 36px 18px 36px;">
                <p style="margin:0 0 16px 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:25px; color:#334155;">
                  Hi <strong style="color:#0b1d3a;">{{Recruiter Name}}</strong>,
                </p>
                <p style="margin:0 0 16px 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:25px; color:#334155;">
                  I am reaching out for Email Developer opportunities. My background includes building responsive email templates, landing pages, email forms, and campaign experiences with a strong focus on QA, rendering consistency, and production-ready code.
                </p>
                <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:25px; color:#334155;">
                  I have hands-on experience with HTML, CSS, AMPscript, Salesforce, Adobe tools, Litmus, Email on Acid, JavaScript, React.js, Node.js, Express, and SQLite.
                </p>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#f8fafc; padding:32px 36px 26px 36px;">
                <p style="margin:0 0 6px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:3px; text-transform:uppercase; color:#0d9488;">
                  Core Skills
                </p>
                <h2 class="section-title" style="margin:0 0 20px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#0b1d3a;">
                  Technical Toolkit
                </h2>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">HTML Email</p>
                    </td>
                    <td class="stack-gap" width="2%">&nbsp;</td>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">CSS / Inline CSS</p>
                    </td>
                    <td class="stack-gap" width="2%">&nbsp;</td>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">AMPscript / SFMC</p>
                    </td>
                  </tr>
                  <tr><td colspan="5" height="10" style="height:10px; font-size:0; line-height:0;">&nbsp;</td></tr>
                  <tr>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">Litmus / EOA</p>
                    </td>
                    <td class="stack-gap" width="2%">&nbsp;</td>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">JavaScript </p>
                    </td>
                    <td class="stack-gap" width="2%">&nbsp;</td>
                    <td class="stack" width="32%" valign="top" style="background-color:#ffffff; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 14px 12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:18px; font-weight:700; color:#0b1d3a;">Email QA</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#ffffff; padding:34px 36px 28px 36px;">
                <p style="margin:0 0 6px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:3px; text-transform:uppercase; color:#0d9488;">
                  What I Do Best
                </p>
                <h2 class="section-title" style="margin:0 0 20px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#0b1d3a;">
                  Email Developer Expertise
                </h2>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td style="border-left:4px solid #0d9488; background-color:#f8fafc; border-top:1px solid #dbe4ee; border-right:1px solid #dbe4ee; border-bottom:1px solid #dbe4ee; padding:18px 20px;">
                      <p style="margin:0 0 6px 0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">Bulletproof Email Templates</p>
                      <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">Table-based HTML, inline CSS, MSO conditionals, responsive structure, and Outlook-aware coding patterns.</p>
                    </td>
                  </tr>
                  <tr><td height="12" style="height:12px; font-size:0; line-height:0;">&nbsp;</td></tr>
                  <tr>
                    <td style="border-left:4px solid #0d9488; background-color:#f8fafc; border-top:1px solid #dbe4ee; border-right:1px solid #dbe4ee; border-bottom:1px solid #dbe4ee; padding:18px 20px;">
                      <p style="margin:0 0 6px 0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">Responsive Campaign Assets</p>
                      <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">Mobile-friendly email templates, landing pages, email forms, and front-end campaign components.</p>
                    </td>
                  </tr>
                  <tr><td height="12" style="height:12px; font-size:0; line-height:0;">&nbsp;</td></tr>
                  <tr>
                    <td style="border-left:4px solid #f59e0b; background-color:#fffaf0; border-top:1px solid #eadcc5; border-right:1px solid #eadcc5; border-bottom:1px solid #eadcc5; padding:18px 20px;">
                      <p style="margin:0 0 6px 0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">Dynamic Personalization</p>
                      <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">AMPscript-powered content for Salesforce Marketing Cloud, including personalization, fallbacks, and campaign logic.</p>
                    </td>
                  </tr>
                  <tr><td height="12" style="height:12px; font-size:0; line-height:0;">&nbsp;</td></tr>
                  <tr>
                    <td style="border-left:4px solid #f59e0b; background-color:#fffaf0; border-top:1px solid #eadcc5; border-right:1px solid #eadcc5; border-bottom:1px solid #eadcc5; padding:18px 20px;">
                      <p style="margin:0 0 6px 0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">QA and Campaign Monitoring</p>
                      <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">Rendering checks, link/functionality validation, operational issue tracking, and live campaign troubleshooting.</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#f8fafc; padding:34px 36px 28px 36px;">
                <p style="margin:0 0 6px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:3px; text-transform:uppercase; color:#0d9488;">
                  Work History
                </p>
                <h2 class="section-title" style="margin:0 0 20px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#0b1d3a;">
                  Professional Experience
                </h2>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#ffffff; border:1px solid #dbe4ee;">
                  <tr>
                    <td style="height:4px; background-color:#0d9488; font-size:0; line-height:0;">&nbsp;</td>
                  </tr>
                  <tr>
                    <td style="padding:20px 22px;">
                      <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                        <tr>
                          <td class="stack" valign="top">
                            <p style="margin:0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:24px; font-weight:700; color:#0b1d3a;">Campaign Analyst</p>
                            <p style="margin:5px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:20px; color:#0d9488; font-weight:700;">Versatiletech - Bangalore, India</p>
                          </td>
                          <td class="stack mobile-center" align="right" valign="top" style="font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; color:#64748b; padding-top:2px;">
                            Sep 2024 - Present
                          </td>
                        </tr>
                      </table>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Identify, troubleshoot, and resolve issues in running campaigns, including rendering problems, functionality breakdowns, and behavioral inconsistencies, ensuring a seamless user experience.
                      </p>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Conduct detailed assessments of campaign performance and monitor for any operational errors, taking proactive measures to address and prevent recurring issues.
                      </p>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Maintain comprehensive tracking of campaign issues, coordinating with cross-functional teams to optimize campaign stability and functionality.
                      </p>
                    </td>
                  </tr>
                </table>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr><td height="14" style="height:14px; font-size:0; line-height:0;">&nbsp;</td></tr>
                </table>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#ffffff; border:1px solid #dbe4ee;">
                  <tr>
                    <td style="height:4px; background-color:#f59e0b; font-size:0; line-height:0;">&nbsp;</td>
                  </tr>
                  <tr>
                    <td style="padding:20px 22px;">
                      <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                        <tr>
                          <td class="stack" valign="top">
                            <p style="margin:0; font-family:Georgia, 'Times New Roman', serif; font-size:18px; line-height:24px; font-weight:700; color:#0b1d3a;">Web Developer - Email </p>
                            <p style="margin:5px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:20px; color:#0d9488; font-weight:700;">Aghreni Technologies - Bangalore</p>
                          </td>
                          <td class="stack mobile-center" align="right" valign="top" style="font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; color:#64748b; padding-top:2px;">
                            Jun 2022 - Sep 2024
                          </td>
                        </tr>
                      </table>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Specializing in developing Rich responsive and Interactive email templates, landing pages, email forms and front-end development.
                      </p>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Experienced with hand-coding HTML and CSS using best practices for coding emails, AMPscript and testing the same with QA tools such as Litmus or Email on Acid using Salesforce, Adobe.
                      </p>
                      <p style="margin:14px 0 0 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#526173;">
                        Web and graphic design experience with Adobe Photoshop and Illustrator, experienced with Adobe Dreamweaver.
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#ffffff; padding:34px 36px 28px 36px;">
                <p style="margin:0 0 6px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:3px; text-transform:uppercase; color:#0d9488;">
                  Education
                </p>
                <h2 class="section-title" style="margin:0 0 20px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#0b1d3a;">
                  Academic Background
                </h2>

                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td class="stack" width="49%" valign="top" style="background-color:#f8fafc; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 16px 18px 8px 18px; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; color:#0d9488;">DEC 2021</p>
                      <p style="margin: 0px 18px 6px 18px; font-family:Arial, Helvetica, sans-serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">Full-Stack Certification</p>
                      <p style="margin: 0px 18px 16px 18px; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:20px; color:#526173;">Nxtwave Disruptive Technologies</p>
                    </td>
                    <td class="stack-gap" width="2%">&nbsp;</td>
                    <td class="stack" width="49%" valign="top" style="background-color:#f8fafc; border:1px solid #dbe4ee; padding: 0px;">
                      <p style="margin: 16px 18px 8px 18px; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; color:#0d9488;">MAY 2019</p>
                      <p style="margin: 0px 18px 6px 18px; font-family:Arial, Helvetica, sans-serif; font-size:18px; line-height:22px; font-weight:700; color:#0b1d3a;">B.Tech - ECE</p>
                      <p style="margin: 0px 18px 16px 18px; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:20px; color:#526173;">MeRITS, Nellore - 146/176 credits</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="mobile-pad" style="background-color:#f8fafc; padding:30px 36px;">
                <p style="margin:0 0 6px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:3px; text-transform:uppercase; color:#0d9488;">
                  Communication
                </p>
                <h2 class="section-title" style="margin:0 0 16px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#0b1d3a;">
                  Languages
                </h2>
                <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:24px; color:#526173;">
                  Telugu - Native<br />
                  English - Advanced C1<br />
                  Kannada - Advanced C1<br />
                  Hindi - Upper Intermediate B2
                </p>
              </td>
            </tr>

            <tr>
              <td align="center" class="mobile-pad" style="background-color:#ffffff; padding:30px 36px;">
                <p style="margin:0 0 20px 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:25px; color:#334155;">
                  I have attached my resume for your review. I would be happy to discuss how I can support your email development and campaign production needs.
                </p>
                <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center">
                  <tr>
                    <td align="center" style="background-color:#0d9488;">
                      <a href="https://sriharim.in" target="_blank" class="button-link" style="display:inline-block; padding:14px 24px; font-family:Arial, Helvetica, sans-serif; font-size:15px; line-height:18px; color:#ffffff; text-decoration:none; font-weight:700; background-color:#0d9488;">
                        View Portfolio
                      </a>
                    </td>
                    <td width="12" style="width:12px; font-size:0; line-height:0;">&nbsp;</td>
                    <td align="center" style="background-color:#0b1d3a;">
                      <a href="https://in.linkedin.com/in/srihari-muppalla" target="_blank" class="button-link" style="display:inline-block; padding:14px 24px; font-family:Arial, Helvetica, sans-serif; font-size:15px; line-height:18px; color:#ffffff; text-decoration:none; font-weight:700; background-color:#0b1d3a;">
                        View LinkedIn
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td align="center" class="mobile-pad" style="background-color:#0b1d3a; padding:34px 36px 30px 36px;">
                <p style="margin:0 0 6px 0; font-family:Georgia, 'Times New Roman', serif; font-size:24px; line-height:30px; font-weight:700; color:#ffffff;">
                  Srihari Muppalla
                </p>
                <p style="margin:0 0 20px 0; font-family:'Courier New', Courier, monospace; font-size:14px; line-height:18px; letter-spacing:2px; text-transform:uppercase; color:#9fb3c8;">
                  Email Developer - Open to Opportunities
                </p>
                <p style="margin:0 0 18px 0; font-family:Arial, Helvetica, sans-serif; font-size:13px; line-height:22px; color:#d7e1ea;">
                  Tumkur, Karnataka, India<br />
                  <a href="mailto:sriharimuppalla64@gmail.com" style="color:#14b8a8; text-decoration:underline;">sriharimuppalla64@gmail.com</a><br />
                  <a href="tel:+919346359910" style="color:#14b8a8; text-decoration:underline;">+91 93463 59910</a>
                </p>
                <p style="margin:0; font-family:Arial, Helvetica, sans-serif; font-size:13px; line-height:22px; color:#d7e1ea;">
                  <a href="https://sriharim.in" target="_blank" style="color:#ffffff; text-decoration:underline;">Portfolio</a>
                  <span style="color:#64748b;"> | </span>
                  <a href="https://in.linkedin.com/in/srihari-muppalla" target="_blank" style="color:#ffffff; text-decoration:underline;">LinkedIn</a>
                </p>
              </td>
            </tr>
          </table>

          <!--[if mso]>
          </td>
          </tr>
          </table>
          <![endif]-->
        </td>
      </tr>
    </table>
  </center>
</body>
</html>

`;